import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { ComponentModule, RootComponent } from './components/inde';
import { IconModule } from '@ant-design/icons-angular';
import { DirectiveModule } from './directives';
import { PUSH_CHANNEL_FACTORY } from './modules/push-notifications';
import { PusherChannelService, PusherModule } from './modules/pusher';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpTokenInjectorService } from './services/http-token-injector/http-token-injector.service';

@NgModule({
  declarations: [],
  imports: [
    FormsModule,
    CommonModule,
    HttpClientModule,
    ComponentModule,
    BrowserModule,
    IconModule,
    DirectiveModule,
    PusherModule,
    BrowserAnimationsModule,
  ],
  providers: [
    { provide: PUSH_CHANNEL_FACTORY, useExisting: PusherChannelService },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpTokenInjectorService,
      multi: true,
    }
  ],
  bootstrap: [RootComponent],
  exports: [],
})
export class AppModule {}
